import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboGrauParentescoComponent } from './combo-grau-parentesco.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboGrauParentescoComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboGrauParentescoComponent]
})
export class ComboGrauParentescoModule { }
